import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa6';
import '../styles/BackButton.css';

/**
 * "Back" link at the top of a detail page. Goes back in the browser history
 * when the visitor came from somewhere on the site; when the page was opened
 * directly (a shared link, a new tab), it goes to the fallback instead.
 */
export default function BackButton({ fallback = '/destinations', label = 'Back' }) {
  const navigate = useNavigate();
  const location = useLocation();
  // React Router gives the very first page of a session the key "default"
  const cameFromSite = location.key && location.key !== 'default';

  return (
    <button
      type='button'
      className='back-button'
      onClick={() => (cameFromSite ? navigate(-1) : navigate(fallback))}
    >
      <FaArrowLeft size={12} aria-hidden='true' />
      <span>{label}</span>
    </button>
  );
}
